import * as pathToRegexp from 'path-to-regexp';

const matchPath = (path, pathname) => {
  const keys = [];
  const re = pathToRegexp(path, keys, {
    end: false,
  });
  const match = re.exec(pathname);

  if (!match) {
    return null;
  }

  const values = match.slice(1);
  return keys.reduce((memo, key, index) => {
    const value = values[index];
    if (value) {
      memo[key.name] = decodeURIComponent(value);
    }
    return memo;
  }, {});
};

export default class PathParams {
  get path() {
    return this._path;
  }

  get absolutePath() {
    return this._parent
      ? `${this._parent.absolutePath}/${this._path}`
      : this._path;
  }

  constructor(path = '/') {
    this._parent = null;
    this._path = path;
  }

  stringify(params, basename) {
    const segments = [''];
    if (basename) {
      segments.push(basename);
    }
    segments.push(this.absolutePath);
    try {
      return pathToRegexp.compile(segments.join('/'))(params);
    } catch (e) {
      throw new Error(e);
    }
  }

  parse(pathname) {
    return matchPath(this.absolutePath, pathname);
  }

  child(path) {
    const child = new PathParams(path);
    child._parent = this;
    return child;
  }

  omitPathParams(params) {
    return pathToRegexp.parse(this._path).reduce(
      (paramsClone, token) => {
        delete paramsClone[token.name];
        return paramsClone;
      },
      { ...params }
    );
  }
}
